module.exports = __webpack_public_path__ + "media/images/cplook/android-chrome-48x48-2694d802ceb50b40462147350bdfe307.png";